import PropTypes from 'prop-types';
import React from 'react';
import { twMerge } from 'tailwind-merge';

const PricingPriceWrap = ({ children, className: additionalClassName }) => {
    return (
        <div
            className={twMerge('py-0 mb-0 flex flex-col', additionalClassName)}
        >
            {children}
        </div>
    );
};

PricingPriceWrap.displayName = 'Pricing__Price_Wrap';

PricingPriceWrap.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
};

export default PricingPriceWrap;
